import { render, staticRenderFns } from "./MetamaskNotConnected.vue?vue&type=template&id=ab40529c&scoped=true&"
import script from "./MetamaskNotConnected.vue?vue&type=script&lang=js&"
export * from "./MetamaskNotConnected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab40529c",
  null
  
)

export default component.exports